import { render, staticRenderFns } from "./deletedInvoicesTable.vue?vue&type=template&id=28e873be&scoped=true&"
import script from "./deletedInvoicesTable.vue?vue&type=script&lang=js&"
export * from "./deletedInvoicesTable.vue?vue&type=script&lang=js&"
import style0 from "./deletedInvoicesTable.vue?vue&type=style&index=0&id=28e873be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e873be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VIcon,VSelect,VTextField})
